"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var animateValues_1 = __importDefault(require("../../animateValues"));
var state_1 = require("../state");
var wizardPresentation_1 = require("./wizardPresentation");
var navigation_1 = require("./navigation");
exports.default = (function (controlButtons) {
    var controlsWrapper = document.querySelector('.FindAnAdvisor__controls');
    var getMatchedButton = controlsWrapper.querySelector('[data-advisor-button-getmatched]');
    var nextButton = controlsWrapper.querySelector('[data-advisor-button-next]');
    var incrementSteps = function () {
        if (state_1.state.activeStep >= state_1.state.totalSteps) {
            return state_1.state.activeStep;
        }
        return state_1.state.activeStep + 1;
    };
    var decrementSteps = function () {
        if (state_1.state.activeStep <= 1) {
            return state_1.state.activeStep;
        }
        return state_1.state.activeStep - 1;
    };
    var getProposedStepFromButton = function (btn) {
        var newStep = state_1.state.activeStep;
        if ('advisorButtonNext' in btn.dataset) {
            newStep = incrementSteps();
        }
        else if ('advisorButtonPrev' in btn.dataset) {
            newStep = decrementSteps();
        }
        else if ('advisorButtonFinish' in btn.dataset) {
            wizardPresentation_1.completeWizard();
        }
        else {
            newStep = state_1.state.totalSteps;
        }
        return newStep;
    };
    var controlButtonEvent = function (e) {
        var btn = e.target;
        var proposedNewStep = getProposedStepFromButton(btn);
        var isValid = navigation_1.validateNavigationChange(proposedNewStep);
        if (!isValid) {
            return false;
        }
        state_1.setState({ activeStep: proposedNewStep });
        if (proposedNewStep > state_1.state.furthestVisitedStep) {
            state_1.setState({ furthestVisitedStep: proposedNewStep });
        }
        return true;
    };
    var hideControls = function () { return controlsWrapper.classList.add('is-hidden'); };
    var showControls = function () {
        controlsWrapper.classList.remove('is-hidden');
        getMatchedButton.classList.add('is-hidden');
        nextButton.classList.remove('is-hidden');
    };
    var getMatchedState = function () {
        getMatchedButton.classList.remove('is-hidden');
        nextButton.classList.add('is-hidden');
    };
    var updateControlsForPane = function (state, _a) {
        var activeStep = _a.activeStep;
        if (activeStep === 1) {
            hideControls();
            return;
        }
        if (activeStep === state.totalSteps) {
            showControls();
            getMatchedState();
            return;
        }
        showControls();
    };
    var countElement = document.querySelector('[data-advisors-count]');
    var updateMatchingAdvisorsCount = function (state, update) {
        var to = update.matchingAdvisors.length;
        var from = parseInt(countElement.innerText) || 0;
        // If count is 0 (after reset) or this is the first display, set directly without animation
        if (from === 0) {
            countElement.innerText = to.toString();
        }
        else {
            // Animate count change for subsequent updates
            animateValues_1.default([to, from], 475, {
                onUpdate: function (v) { return (countElement.innerText = Math.round(v[1]).toString()); }
            });
        }
    };
    state_1.subscribe('matchingAdvisors', updateMatchingAdvisorsCount);
    state_1.subscribe('activeStep', updateControlsForPane);
    controlButtons.forEach(function (button) { return button.addEventListener('click', controlButtonEvent); });
});
